/**
 * authors: Patrick Vyn Badiang and Sean Fleming
 */
//css import
import { Box, Divider, Typography, useMediaQuery } from '@mui/material';
import '../LandingPage/landpage.css';
//mui imports

//global variables
import { useDirection } from '../../UtilityFunctions';
import BoardCard from '../../components/BoardCard';
import OfficersSection from './OfficersSection';

function BoardPage({activeSection}) {

    const isActive = activeSection === "board";
    const direction = useDirection();
    const isSmallScreen = useMediaQuery("(max-width:400px)");

    const execMembers = [
        {
            names: ["Fred"],
            linkedIn: ["https://www.linkedin.com/in/frederick-virtucio-jr/"],
            image: "/img_images/Profiles/Fred_BoardPhoto.jpg",
            position: "Executive Council"
        },
        {
            names: ["Tommy"],
            linkedIn: ["https://www.linkedin.com/in/trinht24/"],
            image: "/img_images/Profiles/Tommy_BoardPhoto.jpg",
            position: "Executive Council"
        },
        {
            names: ["Ariel"],
            linkedIn: ["https://www.linkedin.com/in/ariel08/"],
            image: "/img_images/Profiles/Ariel_BoardPhoto.jpg",
            position: "Executive Council"
        },
        {
            names: ["Patrick"],
            linkedIn: ["https://www.linkedin.com/in/patrick-vyn-badiang/"],
            image: "/img_images/Profiles/Patrick_BoardPhoto.jpg",
            position: "Treasurer"
        },
        {
            names: ["Evan"],
            linkedIn: ["https://www.linkedin.com/in/evan-white-b636302ab/"],
            image: "/img_images/Profiles/Evan_BoardPhoto.jpg",
            position: "Digital Media Specialist"
        }
    ];

    return (
        <div 
        className={`animate__animated ${
      isActive ? "animate__fadeIn" : "animate__fadeOut"
        }`} 
        >
        <div className='entire-page'>
            <Box sx={{ 
                display: "flex", 
                flexDirection: "column", 
                justifyContent: isSmallScreen ?  "start" : "start", 
                alignContent:"center",
                width: "100%", height: direction === "horizontal" ? "100%": "100%", 
                bgcolor: "transparent"}}>

                <Box sx={{ display: 'flex', flexDirection: "row", justifyContent: 'center', alignItems: "center"  ,width: direction === "horizontal" ? "97%" : "90%", height: "80px", bgcolor: "transparent", margin:"20px"}}>
                    <Divider sx={{width: "10%", height: "5px", bgcolor: "#FAF9F6"}}/>
                        <Typography variant="h3"  align='center' color="primary">
                            Executive Board
                        </Typography>
                    <Divider sx={{width: "10%", height: "5px", bgcolor: "#FAF9F6"}}/>
                </Box>
                
                {/* Executive Board Members Cards */}
                <Box sx={{ display: 'flex', flexDirection:  direction === "horizontal" ? "row" : "column", justifyContent: 'center', alignItems: "center", bgcolor: "transparent", gap: 2.0}}>
                {direction === "horizontal" ? (
                    <>
                    {/* Normal order */}
                    {execMembers.slice(0, 3).map((member, index) => (
                        <BoardCard 
                            key={index}
                            names={member.names}
                            linkedIn={member.linkedIn}
                            image={member.image}
                            position={member.position}
                        />
                    ))}
                    </>
                ) : (
                    <>
                    {/* Reverse first three cards */}
                    {execMembers.slice(0, 3).reverse().map((member, index) => (
                        <BoardCard 
                            key={index}
                            names={member.names}
                            linkedIn={member.linkedIn}
                            image={member.image}
                            position={member.position}
                        />
                    ))}
                    </>
                )}
                    {execMembers.slice(3).map((member, index) => (
                        <BoardCard 
                            key={index}
                            names={member.names}
                            linkedIn={member.linkedIn}
                            image={member.image}
                            position={member.position}
                        />
                    ))}
                </Box>
            </Box>
        </div>
        <Box> 
    
    <OfficersSection 
        />
    </Box>
    </div>
    )
}

export default BoardPage;